import React, { useState, useMemo, useEffect } from 'react';
import Sidebar from './sidebar/Sidebar';
import './ChooseTemplate.css';
import downloadIcon from '../assets/download.svg';
import linktofileIcon from '../assets/linktofile.svg';
import arrow from '../assets/arrow.svg';
import filter from '../assets/filter.svg';
import AddDocumentModal from './modals/CreateBlankModal';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Breadcrumbs from "../components/Breadcrumbs";


const PurchaseOrders = () => {
  const [openMenuId, setOpenMenuId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('purchaseOrdersVisibleColumns');
    return savedColumns
      ? JSON.parse(savedColumns)
      : {
          checkbox: true,
          link: true,
          name: true,
          clientName: true,
          dateCreated: true,
          status: true,
          modified: true,
          actions: true,
        };
  });
  const [tempVisibleColumns, setTempVisibleColumns] = useState(visibleColumns); // Temporary state for column options

  useEffect(() => {
    localStorage.setItem('purchaseOrdersVisibleColumns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const handleOpenDocument = () => {
    const documentUrl =
      'https://criticalrivertechnologies.sharepoint.com/:w:/r/sites/CR-CLM/_layouts/15/Doc.aspx?sourcedoc=%7B2236E697-7BD4-4C36-BBC4-6EAFB353E19E%7D&file=CR-CLM-Testdoc.docx&action=default&mobileredirect=true';
    console.log('Opening document at:', documentUrl);
    // window.open(documentUrl, '_blank');
    window.open(documentUrl, '_blank', 'noopener,noreferrer');
  };

  const templates = [
    {
      id: 1,
      name: 'Purchase Order #001',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Ramesh Kumar',
      date: '14/03/2023',
      rawDate: new Date('2023-03-14'),
      status: 'Draft',
      statusColor: '#6B7280',
      modified: '4 hours ago',
      rawModified: new Date(Date.now() - 4 * 60 * 60 * 1000),
    },
    {
      id: 2,
      name: 'Equipment Purchase Order',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Sonal Mehta',
      date: '09/04/2023',
      rawDate: new Date('2023-04-09'),
      status: 'Sent',
      statusColor: '#F59E0B',
      modified: '2 days ago',
      rawModified: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    },
    {
      id: 3,
      name: 'Software License PO',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Vikram Singh',
      date: '22/06/2023',
      rawDate: new Date('2023-06-22'),
      status: 'Completed',
      statusColor: '#10B981',
      modified: '5 hours ago',
      rawModified: new Date(Date.now() - 5 * 60 * 60 * 1000),
    },
    {
      id: 4,
      name: 'Hardware Order #2023',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Neha Sharma',
      date: '03/02/2023',
      rawDate: new Date('2023-02-03'),
      status: 'Draft',
      statusColor: '#6B7280',
      modified: '4 months ago',
      rawModified: new Date(Date.now() - 4 * 30 * 24 * 60 * 60 * 1000),
    },
    {
      id: 5,
      name: 'Office Furniture Purchase',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Ankit Verma',
      date: '28/07/2023',
      rawDate: new Date('2023-07-28'),
      status: 'Completed',
      statusColor: '#10B981',
      modified: '1 week ago',
      rawModified: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    },
    {
      id: 6,
      name: 'Annual Maintenance PO',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Pooja Desai',
      date: '12/08/2023',
      rawDate: new Date('2023-08-12'),
      status: 'Sent',
      statusColor: '#F59E0B',
      modified: '3 days ago',
      rawModified: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    },
    {
      id: 7,
      name: 'Networking Equipment Order',
      tag: 'PO',
      tagColor: '#FF6B35',
      type: 'Amitabh Joshi',
      date: '05/09/2023',
      rawDate: new Date('2023-09-05'),
      status: 'Draft',
      statusColor: '#6B7280',
      modified: '10 hours ago',
      rawModified: new Date(Date.now() - 10 * 60 * 60 * 1000),
    },
  ];

  const handleSort = (key) => {
    setSortConfig((prevConfig) => {
      if (prevConfig.key === key && prevConfig.direction === 'asc') {
        return { key, direction: 'desc' };
      }
      return { key, direction: 'asc' };
    });
  };

  const sortedTemplates = useMemo(() => {
    let sortableTemplates = [...templates];
    if (sortConfig.key) {
      sortableTemplates.sort((a, b) => {
        let aValue = sortConfig.key === 'dateCreated' ? a.rawDate : a.rawModified;
        let bValue = sortConfig.key === 'dateCreated' ? b.rawDate : b.rawModified;
        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return sortableTemplates;
  }, [templates, sortConfig]);

  const filteredTemplates = sortedTemplates.filter((template) => {
    const matchesSearch =
      template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.modified.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = !isFiltered || template.status === 'Draft';
    return matchesSearch && matchesFilter;
  });

  const itemsPerPage = rowsPerPage;
  const totalTemplates = templates.length;
  const totalPages = Math.max(1, Math.ceil(filteredTemplates.length / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredTemplates.length);
  const currentTemplates = useMemo(() => filteredTemplates.slice(startIndex, endIndex), [filteredTemplates, startIndex, endIndex]);

  const exportTableToCSV = () => {
    const headers = ['Contract Name', 'Tag', 'Client Name', 'Created Date', 'Status', 'Modified'];
    const rows = filteredTemplates.map((t) => [t.name, t.tag, t.type, t.date, t.status, t.modified].join(','));
    const csvContent = `data:text/csv;charset=utf-8,${headers.join(',')}\n${rows.join('\n')}`;
    const encoded = encodeURI(csvContent);
    const a = document.createElement('a');
    a.href = encoded;
    a.download = 'purchase_orders.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setShowDownloadMenu(false);
  };

  const exportTablePDF = () => {
    const doc = new jsPDF();
    doc.text('Purchase Orders', 10, 10);
    autoTable(doc, {
      startY: 20,
      head: [['Contract Name', 'Tag', 'Client Name', 'Created Date', 'Status', 'Modified']],
      body: filteredTemplates.map((t) => [t.name, t.tag, t.type, t.date, t.status, t.modified]),
    });
    doc.save('purchase_orders.pdf');
    setShowDownloadMenu(false);
  };

  const toggleColumn = (key) => {
    setTempVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleColumnOptionsConfirm = () => {
    setVisibleColumns(tempVisibleColumns);
    setShowColumnOptions(false);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedTemplates(templates.map((t) => t.id));
    } else {
      setSelectedTemplates([]);
    }
  };

  const handleTemplateSelect = (templateId) => {
    if (selectedTemplates.includes(templateId)) {
      setSelectedTemplates(selectedTemplates.filter((id) => id !== templateId));
    } else {
      setSelectedTemplates([...selectedTemplates, templateId]);
    }
    if (selectedTemplates.length + 1 < templates.length && !selectedTemplates.includes(templateId)) {
      setSelectAll(false);
    }
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const handleFilterToggle = () => {
    setIsFiltered(false);
    setSearchTerm('');
  };

  const handleViewTemplate = (template) => {
    setSelectedTemplate(template);
    setIsViewModalOpen(true);
  };

  const handleUseTemplate = () => {
    setIsAddDocumentModalOpen(true);
  };

  return (
    <div className="choose-template-container">
      <Sidebar />
      <div className="main-content">
      <Breadcrumbs /><br/>
        <div className="header-section1">
          <h2 className="title">Purchase Orders</h2>
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className="filter-btn" onClick={handleFilterToggle}>
              <img src={filter} alt="Filter" className="filter-image" /> Filter
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', margin: '8px 0' }}>
          <button
            onClick={() => { setShowColumnOptions(true); setTempVisibleColumns(visibleColumns); }}
            style={{
              cursor: 'pointer',
              padding: '4px 12px',
              borderRadius: '6px',
              background: 'transparent',
              color: '#4A4A4A',
              border: '1px solid black',
              fontSize: '16px',
              fontWeight: 500,
            }}
          >
            ⚙ Column options
          </button>
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setShowDownloadMenu(!showDownloadMenu)}
              style={{
                cursor: 'pointer',
                padding: '4px 12px',
                borderRadius: '6px',
                background: 'transparent',
                border: '1px solid black',
                color: '#4A4A4A',
                fontSize: '16px',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              <img src={downloadIcon} alt="Download" style={{ width: '16px', height: '20px' }} /> Download
            </button>
            {showDownloadMenu && (
              <div
                className="Project-export-dropdown"
                style={{ position: 'absolute', right: 0, marginTop: '6px', borderRadius: '6px' }}
              >
                <button
                  onClick={exportTableToCSV}
                  style={{
                    cursor: 'pointer',
                    border: 'none',
                    display: 'block',
                    padding: '8px 12px',
                    width: '120px',
                    textAlign: 'left',
                    background: 'none',
                    color: '#4A4A4A',
                  }}
                >
                  Download CSV
                </button>
                <button
                  onClick={exportTablePDF}
                  style={{
                    cursor: 'pointer',
                    border: 'none',
                    display: 'block',
                    padding: '8px 12px',
                    width: '120px',
                    textAlign: 'left',
                    background: 'none',
                    color: '#4A4A4A',
                  }}
                >
                  Download PDF
                </button>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#4A4A4A', fontSize: '15px', fontWeight: 600 }}>
            Results: {filteredTemplates.length === 0 ? 0 : startIndex + 1}-{endIndex} of {filteredTemplates.length}
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                paddingLeft: '10px',
                color: '#4A4A4A',
                fontSize: '16px',
                fontWeight: 500,
                backgroundColor: '#e5e7eb',
                width: '60px',
                height: '36px',
                borderRadius: '6px',
                border: 'none',
              }}
            >
              {[5, 10, 15, 20].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="table-container">
          <table className="template-table">
            <thead>
              <tr>
                {visibleColumns.checkbox && (
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      style={{ marginLeft: '25px' }}
                    />
                  </th>
                )}
                {visibleColumns.link && <th></th>}
                {visibleColumns.name && (
                  <th>Contract Name</th>
                )}
                {visibleColumns.clientName && <th>Client Name</th>}
                {visibleColumns.dateCreated && (
                  <th style={{ cursor: 'pointer' }} onClick={() => handleSort('dateCreated')}>
                    Created Date
                    <span className="sort-icon">
                      <img
                        src={arrow}
                        alt="sort arrow"
                        className="arrow"
                        style={{
                          transform: sortConfig.key === 'dateCreated' && sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
                          opacity: sortConfig.key === 'dateCreated' ? 1 : 0.3,
                        }}
                      />
                    </span>
                  </th>
                )}
                {visibleColumns.status && <th>Status</th>}
                {visibleColumns.modified && (
                  <th style={{ cursor: 'pointer' }} onClick={() => handleSort('modified')}>
                    Modified
                    <span className="sort-icon">
                      <img
                        src={arrow}
                        alt="sort arrow"
                        className="arrow"
                        style={{
                          transform: sortConfig.key === 'modified' && sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
                          opacity: sortConfig.key === 'modified' ? 1 : 0.3,
                        }}
                      />
                    </span>
                  </th>
                )}
                {visibleColumns.actions && <th className="actions-header"></th>}
              </tr>
            </thead>
            <tbody>
              {currentTemplates.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', padding: '20px', color: '#4A5568' }}>
                    No data found
                  </td>
                </tr>
              ) : (
                currentTemplates.map((template) => (
                  <tr key={template.id}>
                    {visibleColumns.checkbox && (
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedTemplates.includes(template.id)}
                          onChange={() => handleTemplateSelect(template.id)}
                          style={{ marginLeft: '25px' }}
                        />
                      </td>
                    )}
                    {visibleColumns.link && (
                      <td>
                        <img src={linktofileIcon} alt="Link to File" className="link-icon" />
                      </td>
                    )}
                    {visibleColumns.name && (
                      <td style={{ cursor: 'pointer' }} onClick={handleOpenDocument}>
                        {template.name}
                        <div className="tag-container">
                          <span className="tag" style={{ backgroundColor: template.tagColor }}>
                            {template.tag}
                          </span>
                        </div>
                      </td>
                    )}
                    {visibleColumns.clientName && <td>{template.type}</td>}
                    {visibleColumns.dateCreated && <td>{template.date}</td>}
                    {visibleColumns.status && (
                      <td>
                        <span className="status-dot" style={{ backgroundColor: template.statusColor }}></span>
                        {template.status}
                      </td>
                    )}
                    {visibleColumns.modified && <td>{template.modified}</td>}
                    {visibleColumns.actions && (
                      <td className="actions-cell">
                        <button className="action-btn download-btn">
                          <img src={downloadIcon} alt="Download" className="action-image" />
                        </button>
                        <button className="action-btn view-btn" onClick={() => handleViewTemplate(template)}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </button>
                        <button className="action-btn use-btn" onClick={handleUseTemplate}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polygon points="5 3 19 12 5 21 5 3" />
                          </svg>
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
            <nav style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '18px',
                  border: '1px solid #2563EB',
                  background: currentPage === 1 ? '#f3f4f6' : '#fff',
                  color: currentPage === 1 ? '#9ca3af' : '#2563EB',
                }}
              >
                {'<'}
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '18px',
                    border: '1px solid #2563EB',
                    background: page === currentPage ? '#2563EB' : '#fff',
                    color: page === currentPage ? '#fff' : '#2563EB',
                    cursor: 'pointer',
                  }}
                >
                  {page}
                </button>
              ))}
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '18px',
                  border: '1px solid #2563EB',
                  background: currentPage === totalPages ? '#f3f4f6' : '#fff',
                  color: currentPage === totalPages ? '#9ca3af' : '#2563EB',
                }}
              >
                {'>'}
              </button>
            </nav>
          </div>
        )}
        {showColumnOptions && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.4)',
              backdropFilter: 'blur(6px)',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              zIndex: 1000,
            }}
          >
            <div
              style={{
                width: '340px',
                background: '#fff',
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                marginTop: '100px',
                marginRight: '20px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px 12px',
                  fontWeight: 700,
                }}
              >
                <div>Column Options</div>
                <button
                  onClick={() => setShowColumnOptions(false)}
                  aria-label="Close"
                  style={{ background: 'transparent', border: 'none', fontSize: '25px', cursor: 'pointer' }}
                >
                  ×
                </button>
              </div>
              <div
                style={{
                  marginTop: '-8px',
                  fontSize: '12px',
                  color: '#6B7280',
                  padding: '0 12px 8px',
                  borderBottom: '1px solid #e5e7eb',
                }}
              >
                Click the icon to show or hide columns.
              </div>
              <div style={{ maxHeight: '50vh', overflowY: 'auto', padding: '10px 12px' }}>
                {['checkbox', 'link', 'name', 'clientName', 'dateCreated', 'status', 'modified', 'actions'].map(
                  (key) => (
                    <div
                      key={key}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '8px 0',
                        borderBottom: '1px solid #f3f4f6',
                      }}
                    >
                      <span style={{ fontSize: '14px', color: '#111827' }}>
                        {key === 'name' ? 'Contract Name' : key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                      </span>
                      <button
                        onClick={() => toggleColumn(key)}
                        aria-label={tempVisibleColumns[key] ? `Hide ${key}` : `Show ${key}`}
                        style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                          {!tempVisibleColumns[key] && (
                            <line x1="2" y1="2" x2="18" y2="18" stroke="#000000" strokeWidth="3" />
                          )}
                        </svg>
                      </button>
                    </div>
                  )
                )}
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px 12px', borderTop: '1px solid #e5e7eb' }}>
                <button
                  onClick={() => setShowColumnOptions(false)}
                  style={{ background: 'transparent', color: '#2563EB', border: '1px solid #2563EB', padding: '8px 14px', borderRadius: '6px' }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleColumnOptionsConfirm}
                  style={{ background: '#2563EB', color: '#fff', border: '1px solid #2563EB', padding: '8px 14px', borderRadius: '6px' }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
        {isViewModalOpen && (
          <div className="modal-overlay" onClick={() => setIsViewModalOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>View Purchase Order</h2>
                <button className="close-btn" onClick={() => setIsViewModalOpen(false)}>
                  <span>×</span>
                </button>
              </div>
              <div className="modal-body">
                <h3>{selectedTemplate?.name}</h3>
                <p>
                  <strong>Type:</strong> {selectedTemplate?.type}
                </p>
                <p>
                  <strong>Created Date:</strong> {selectedTemplate?.date}
                </p>
                <p>
                  <strong>Status:</strong> {selectedTemplate?.status}
                </p>
                <p>
                  <strong>Modified:</strong> {selectedTemplate?.modified}
                </p>
              </div>
            </div>
          </div>
        )}
        <AddDocumentModal
          isOpen={isAddDocumentModalOpen}
          onClose={() => setIsAddDocumentModalOpen(false)}
          onSelectTemplate={() => {}}
        />
      </div>
    </div>
  );
};

export default PurchaseOrders;